"use client";

import React, { type ReactElement } from "react";

interface GlobalPageHeaderProps {
  title: string;
  lead?: string;
}

function GlobalPageHeader({
  title,
  lead,
}: Readonly<GlobalPageHeaderProps>): ReactElement {
  return (
    <header className="min-h-32 flex flex-row items-end border-b bg-accent overflow-hidden">
      <div className="max-w-7xl mx-auto flex-1 flex flex-col gap-1 p-4 animate__animated animate__slideInUp animate__faster">
        <h1 className="text-2xl md:text-3xl font-semibold">{title}</h1>
        {lead ? <p className="opacity-50">{lead}</p> : null}
      </div>
    </header>
  );
}

export { GlobalPageHeader, type GlobalPageHeaderProps };
